import request from '@/utils/request'
import assign from '@/utils/assign'
import apiPath from '@/api/apiPath'
import qs from 'qs'

const defaultOptions = {
  platform: 'wechat',
}

// 课程中心 科目列表接口 【在线课程|章节练习|模拟考试】
export function fetchCourseCenter(params) {
  return request({
    url: apiPath.CourseCenter,
    method: 'get',
    noToast: true,
    params: assign(defaultOptions, { ...params }),
  })
}

// 课程章节列表 【在线课程|章节练习】
export function fetchCourseChapterLists({ subject_id, type = null }) {
  return request({
    url: apiPath.CourseChapterLists,
    method: 'get',
    params: assign(defaultOptions, {
      subject_id,
      type,
    }),
  })
}

// 在线课程详情页
export function fetchCourseChapterDetails({ chapter_id }) {
  return request({
    url: apiPath.CourseChapterDetails,
    method: 'get',
    params: assign(defaultOptions, {
      chapter_id,
    }),
  })
}
// 获取阿里云 playauth (音、视、课件)
export function fetchCourseChapterDetailsPlayAuth({ video_id }) {
  return request({
    url: apiPath.CourseChapterDetailsPlayAuth,
    method: 'get',
    noFullScreenLoading: true,
    params: assign(defaultOptions, {
      video_id,
    }),
  })
}
// 获取阿里云 playurl(音、视、课件)
export function fetchCourseChapterDetailsPlayUrl({ video_id }) {
  return request({
    url: apiPath.CourseChapterDetailsPlayUrl,
    method: 'get',
    noFullScreenLoading: true,
    params: assign(defaultOptions, {
      video_id,
    }),
  })
}
// 在线课程详情页中 点击不同的内容时发送 course_id
export function fetchCourseChapterDetailsItemRecord({ course_id }) {
  return request({
    url: apiPath.CourseChapterDetailsItemRecord,
    method: 'get',
    noFullScreenLoading: true,
    params: assign(defaultOptions, {
      course_id,
    }),
  })
}
// 在线课程详情页中 点击不同的内容时发送 course_id
export function fetchCourseChapterDetailsRecordCourse({
  chapter_id,
  course_id,
  curr_time,
}) {
  return request({
    url: apiPath.CourseChapterDetailsRecordCourse,
    method: 'get',
    noFullScreenLoading: true,
    params: assign(defaultOptions, {
      chapter_id,
      course_id,
      curr_time,
    }),
  })
}

//// 章节练习
// 判断是否有章节练习的记录
export function fetchSubjectPracticeHistory(data) {
  return request({
    url: apiPath.SubjectPracticeHistory,
    method: 'get',
    params: assign(defaultOptions, data),
  })
}
// 是否继续上一次练习接口
export function fetchSubjectChapterContinueDetails(data) {
  return request({
    url: apiPath.SubjectChapterContinueDetails,
    method: 'get',
    params: assign(defaultOptions, data),
  })
}
// 章节练习详情页
export function fetchSubjectChapterDetails(data) {
  return request({
    url: apiPath.SubjectChapterDetails,
    method: 'get',
    params: assign(defaultOptions, data),
  })
}
// 章节练习详情页 多选题
export function fetchSubjectChapterDetailsCheckbox(data) {
  return request({
    url: apiPath.SubjectChapterCheckboxList,
    method: 'get',
    params: assign(defaultOptions, data),
  })
}
// 记录章节练习的位置 （当用户做完所有的题的时候请传入position=0）
export function fetchSubjectPracticePositionSave(data) {
  return request({
    url: apiPath.SubjectPracticePositionSave,
    method: 'get',
    params: assign(defaultOptions, data),
  })
}

//// 模拟考试
// 判断是否有模拟考试的记录
export function fetchMockTestHistory(data) {
  return request({
    url: apiPath.MockTestHistory,
    method: 'get',
    params: assign(defaultOptions, { ...data }),
  })
}
// 获取模拟试卷接口
export function fetchMockTestDetails(data) {
  return request({
    url: apiPath.MockTestDetails,
    method: 'get',
    params: assign(defaultOptions, {
      ...data,
    }),
  })
}
// 模拟卷考试题回答提交接口
export function fetchMockTestSubmit(data) {
  return request({
    url: apiPath.MockTestSubmit,
    method: 'get',
    params: assign(defaultOptions, {
      ...data,
    }),
  })
}
// 模拟卷答题统计接口
export function fetchMockTestAnswerStatistic({ answer_id }) {
  return request({
    url: apiPath.MockTestAnswerStatistic,
    method: 'get',
    params: assign(defaultOptions, {
      answer_id,
    }),
  })
}

//// 个人中心
// 判断用户是否登录
export function fetchIsLogin() {
  return request({
    url: apiPath.IsLogin,
    method: 'get',
    noToast: true,
    params: assign(defaultOptions),
  })
}
// 微信个人信息
export function fetchWechatUserInfo() {
  return request({
    url: apiPath.WechatUserInfo,
    method: 'get',
    noToast: true,
    params: assign(defaultOptions),
  })
}
// 身份证
export function fetchHasIDCard() {
  return request({
    url: apiPath.HasIDCard,
    method: 'get',
    noToast: true,
    params: assign(defaultOptions),
  })
}
// 判断是否是学生
export function fetchIsStudent() {
  return request({
    url: apiPath.IsStudent,
    method: 'get',
    noToast: true,
    params: assign(defaultOptions),
  })
}

// 发送手机号 获取验证码
export function fetchPhoneSignUpCode({ mobile }) {
  return request({
    url: apiPath.PhoneSignUpCode,
    method: 'get',
    params: assign(defaultOptions, {
      mobile,
    }),
  })
}
// 输入验证码后， 发送验证
export function fetchPhoneSignUpVerify({ mobile, code }) {
  return request({
    url: apiPath.PhoneSignUpVerify,
    method: 'get',
    params: assign(defaultOptions, {
      mobile,
      code,
    }),
  })
}

// 考试记录
export function fetchMockTestRecordsHistoryList() {
  return request({
    url: apiPath.MockTestRecordsHistoryList,
    method: 'get',
    params: assign(defaultOptions),
  })
}
export function fetchMockTestRecordsHistoryDetails({ answer_id }) {
  return request({
    url: apiPath.MockTestRecordsHistoryDetails,
    method: 'get',
    params: assign(defaultOptions, { answer_id }),
  })
}

// 错题集
export function fetchMistakeCollectionList() {
  return request({
    url: apiPath.MistakeCollectionList,
    method: 'get',
    params: assign(defaultOptions),
  })
}
export function fetchMistakeCollectionDetails({ answer_id }) {
  return request({
    url: apiPath.MistakeCollectionDetails,
    method: 'get',
    params: assign(defaultOptions, {
      answer_id,
    }),
  })
}

// 在线购买
export function fetchOrderGetPayInfo({ subject_id, type }) {
  return request({
    url: apiPath.OrderGetPayInfo,
    method: 'get',
    params: assign(defaultOptions, { subject_id, type }),
  })
}
export function fetchOrderGenerate({ title, info, name, idcard }) {
  let options = {
    title,
    info,
  }
  if (name || idcard) {
    options.name = name
    options.idcard = idcard
  }
  const data = qs.stringify(assign(defaultOptions, options))
  const params = {
    url: apiPath.OrderGenerate,
    method: 'post',
    params: {
      platform: 'wechat',
    },
    data,
  }
  return request(params)
}

// 获得订单列表
export function getOrderList({ page }) {
  return request({
    url: apiPath.OrderList,
    method: 'get',
    params: assign(defaultOptions, { page }),
  })
}

// 获得历史真题列表
export function getPassYearsList() {
  return request({
    url: apiPath.PassedYearsExamination,
    method: 'get',
    params: assign(defaultOptions),
  })
}

// 获取模拟/结业/历年真题考试/章节练习试卷
export function fetchGeneratingExamination(data) {
  return request({
    url: apiPath.GeneratingExamination,
    method: 'get',
    params: assign(defaultOptions, {
      ...data,
    }),
  })
}

// 保存答题记录（回答一题保存一题）
export function fetchSaveAnswerResults(data) {
  return request({
    url: apiPath.SaveAnswerResults,
    method: 'get',
    params: assign(defaultOptions, {
      ...data,
    }),
  })
}

//获取科目分类
export function CertList(params) {
  return request({
    url: apiPath.CertList,
    method: 'get',
    params: assign(defaultOptions, { ...params }),
  })
}
//获取证书信息
export function CertDetail(params) {
  return request({
    url: apiPath.CertDetail,
    method: 'get',
    params: assign(defaultOptions, { ...params }),
  })
}
//获取科目分类
export function UserGetSubjectCategories(params) {
  return request({
    url: apiPath.UserGetSubjectCategories,
    method: 'get',
    params: assign(defaultOptions, { ...params }),
  })
}
// 文件上传
export function Upload(params, config) {
  return request.post(apiPath.Upload, params, config)
}
//获取教师信息
export function TeacherDetail(params) {
  return request({
    url: apiPath.TeacherDetail,
    method: 'get',
    params: assign(defaultOptions, { ...params }),
  })
}
//获取教师信息
export function SignupSave(params) {
  return request({
    url: apiPath.SignupSave,
    method: 'post',
    data: assign(defaultOptions, { ...params }),
  })
}

//获取国考科目
export function getNationalgetSubjects(params) {
  return request({
    url: apiPath.nationalgetSubjects,
    method: 'get',
    noToast: true,
    params: assign(defaultOptions, { ...params }),
  })
}

//获取国考科目课程
export function getNationalgetCourseInfo(params) {
  return request({
    url: apiPath.nationalgetCourseInfo,
    method: 'get',
    noToast: true,
    params: assign(defaultOptions, { ...params }),
  })
}

//获取国考学习记录
export function getNationalRecordCours(params) {
  return request({
    url: apiPath.nationalRecordCourse,
    method: 'get',
    noToast: true,
    params: assign(defaultOptions, { ...params }),
  })
}

//国考是否答完
export function checkPreviousRandomExamination(params) {
  return request({
    url: apiPath.nationalcheckPreviousRandomExamination,
    method: 'get',
    noToast: true,
    params: assign(defaultOptions, { ...params }),
  })
}

//国考试卷
export function nationalgeneratingRandomExamination(params) {
  return request({
    url: apiPath.nationalgeneratingRandomExamination,
    method: 'get',
    noToast: true,
    params: assign(defaultOptions, { ...params }),
  })
}

//国考提交
export function nationalsaveAnswerResults(params) {
  return request({
    url: apiPath.nationalsaveAnswerResults,
    method: 'get',
    noToast: true,
    params: assign(defaultOptions, { ...params }),
  })
}

//国考总结
export function nationalanswerStatistics(params) {
  return request({
    url: apiPath.nationalanswerStatistics,
    method: 'get',
    noToast: true,
    params: assign(defaultOptions, { ...params }),
  })
}

//国考总结
export function nationalExaminationRecordInfo(params) {
  return request({
    url: apiPath.nationalExaminationRecordInfo,
    method: 'get',
    noToast: true,
    params: assign(defaultOptions, { ...params }),
  })
}

// 报名页 培训科目列表
export function fetchSignupSubjects(params) {
  return request({
    url: apiPath.signupSubjects,
    method: 'get',
    noToast: true,
    params: assign(defaultOptions, { ...params }),
  })
}
